var map = {
	"./alert.svg": [
		61611,
		61611
	],
	"./filled/Credito_automatico.svg": [
		92763,
		92763
	],
	"./filled/Credito_consignado.svg": [
		54708,
		54708
	],
	"./filled/Credito_imobiliario.svg": [
		1823,
		1823
	],
	"./filled/Itoken.svg": [
		54970,
		54970
	],
	"./filled/Viagem.svg": [
		20915,
		20915
	],
	"./filled/acoes.svg": [
		29638,
		7257
	],
	"./filled/agencia-personalite.svg": [
		59891,
		59891
	],
	"./filled/agencia.svg": [
		3444,
		3444
	],
	"./filled/agil.svg": [
		41029,
		41029
	],
	"./filled/ajuda.svg": [
		42905,
		42905
	],
	"./filled/alimentacao.svg": [
		48906,
		48906
	],
	"./filled/alvo.svg": [
		35028,
		35028
	],
	"./filled/antecipacao_de_recebimento.svg": [
		11134,
		11134
	],
	"./filled/aplicativos.svg": [
		45947,
		45947
	],
	"./filled/aporte-de-capital.svg": [
		82694,
		82694
	],
	"./filled/ar_condicionado.svg": [
		55838,
		55838
	],
	"./filled/armario.svg": [
		56293,
		56293
	],
	"./filled/arroba.svg": [
		30809,
		30809
	],
	"./filled/atendimento.svg": [
		69524,
		69524
	],
	"./filled/atualizando.svg": [
		42562,
		42562
	],
	"./filled/autoriza-pelo-celular.svg": [
		93303,
		93303
	],
	"./filled/aviso.svg": [
		78874,
		78874
	],
	"./filled/balanco-de-caixa.svg": [
		19867,
		19867
	],
	"./filled/beleza.svg": [
		44243,
		44243
	],
	"./filled/beneficios.svg": [
		33363,
		33363
	],
	"./filled/bike.svg": [
		5221,
		5221
	],
	"./filled/biometria.svg": [
		54898,
		54898
	],
	"./filled/brilho-nos-olhos.svg": [
		50383,
		50383
	],
	"./filled/busca.svg": [
		50084,
		50084
	],
	"./filled/caixa-eletronico.svg": [
		11367,
		11367
	],
	"./filled/calendario.svg": [
		81376,
		81376
	],
	"./filled/carrinho.svg": [
		47488,
		47488
	],
	"./filled/cartao-de-seguranca.svg": [
		93272,
		93272
	],
	"./filled/cartao.svg": [
		89076,
		89076
	],
	"./filled/carteira-digital.svg": [
		25846,
		25846
	],
	"./filled/carteiras-digitais-full.svg": [
		59541,
		59541
	],
	"./filled/cartoes.svg": [
		53787,
		53787
	],
	"./filled/celular-pre-pago.svg": [
		64618,
		64618
	],
	"./filled/celular.svg": [
		93940,
		93940
	],
	"./filled/chat-aguardando.svg": [
		7687,
		7687
	],
	"./filled/chat-erro.svg": [
		98942,
		76561
	],
	"./filled/chave.svg": [
		70711,
		70711
	],
	"./filled/checkbox.svg": [
		35493,
		35493
	],
	"./filled/cheque.svg": [
		79627,
		79627
	],
	"./filled/chip.svg": [
		35280,
		35280
	],
	"./filled/cifrao.svg": [
		30810,
		30810
	],
	"./filled/cinema.svg": [
		20695,
		20695
	],
	"./filled/coleta.svg": [
		6944,
		6944
	],
	"./filled/compartilhar.svg": [
		49818,
		49818
	],
	"./filled/compra.svg": [
		83008,
		83008
	],
	"./filled/compras.svg": [
		39395,
		39395
	],
	"./filled/comprovante.svg": [
		23648,
		23648
	],
	"./filled/computador.svg": [
		34932,
		34932
	],
	"./filled/configuracao.svg": [
		57901,
		57901
	],
	"./filled/confirmacao.svg": [
		9410,
		9410
	],
	"./filled/cons-investimento.svg": [
		25989,
		25989
	],
	"./filled/consorcio-auto.svg": [
		87179,
		87179
	],
	"./filled/consorcio-imobiliario.svg": [
		87664,
		87664
	],
	"./filled/consorcio.svg": [
		85381,
		85381
	],
	"./filled/conta-corrente.svg": [
		53462,
		53462
	],
	"./filled/contatos.svg": [
		86639,
		86639
	],
	"./filled/copiar.svg": [
		67568,
		67568
	],
	"./filled/craques.svg": [
		87420,
		87420
	],
	"./filled/credito-auto.svg": [
		31724,
		31724
	],
	"./filled/credito-sob-medida.svg": [
		94966,
		94966
	],
	"./filled/credito.svg": [
		63624,
		63624
	],
	"./filled/csv.svg": [
		66086,
		66086
	],
	"./filled/cultura.svg": [
		25148,
		25148
	],
	"./filled/curtir.svg": [
		10557,
		10557
	],
	"./filled/debito.svg": [
		8367,
		8367
	],
	"./filled/desafios.svg": [
		33602,
		33602
	],
	"./filled/desbloqueio.svg": [
		49474,
		49474
	],
	"./filled/descurtir.svg": [
		51229,
		51229
	],
	"./filled/diario.svg": [
		27466,
		27466
	],
	"./filled/documento.svg": [
		41080,
		41080
	],
	"./filled/documentos-pasta.svg": [
		76233,
		76233
	],
	"./filled/download.svg": [
		42182,
		42182
	],
	"./filled/editar.svg": [
		17727,
		17727
	],
	"./filled/email-resposta-rapida.svg": [
		47792,
		47792
	],
	"./filled/empresa.svg": [
		52103,
		52103
	],
	"./filled/emprestimo.svg": [
		93407,
		93407
	],
	"./filled/enviar.svg": [
		42653,
		42653
	],
	"./filled/esporte.svg": [
		65840,
		65840
	],
	"./filled/excel.svg": [
		42535,
		42535
	],
	"./filled/excluir.svg": [
		83640,
		83640
	],
	"./filled/facebook.svg": [
		19850,
		19850
	],
	"./filled/fatura.svg": [
		2091,
		2091
	],
	"./filled/favorito.svg": [
		19176,
		19176
	],
	"./filled/feedback.svg": [
		69275,
		69275
	],
	"./filled/fingerprint.svg": [
		77678,
		77678
	],
	"./filled/flash-desabilitado.svg": [
		9880,
		9880
	],
	"./filled/flash-habilitado.svg": [
		11680,
		11680
	],
	"./filled/futebol.svg": [
		14655,
		14655
	],
	"./filled/garantia.svg": [
		69937,
		69937
	],
	"./filled/gerenciador-de-vendas.svg": [
		6677,
		6677
	],
	"./filled/gestao-de-crises.svg": [
		50365,
		50365
	],
	"./filled/globo.svg": [
		78847,
		78847
	],
	"./filled/historico-de-rentabilidade.svg": [
		37631,
		37631
	],
	"./filled/home.svg": [
		17887,
		17887
	],
	"./filled/impressora.svg": [
		36771,
		36771
	],
	"./filled/informacao.svg": [
		84457,
		84457
	],
	"./filled/inovacao.svg": [
		7564,
		7564
	],
	"./filled/instagram.svg": [
		28446,
		28446
	],
	"./filled/institucional.svg": [
		69530,
		69530
	],
	"./filled/investimento.svg": [
		56241,
		56241
	],
	"./filled/itaupass.svg": [
		33336,
		33336
	],
	"./filled/itoken-chaveiro.svg": [
		45044,
		45044
	],
	"./filled/jornal.svg": [
		54412,
		54412
	],
	"./filled/lavagem-de-dinheiro.svg": [
		56608,
		34227
	],
	"./filled/lideranca.svg": [
		9265,
		9265
	],
	"./filled/limite.svg": [
		59876,
		59876
	],
	"./filled/link-externo.svg": [
		76848,
		76848
	],
	"./filled/logo-itau.svg": [
		66081,
		53993
	],
	"./filled/logo-laranja.svg": [
		23819,
		53993
	],
	"./filled/loja.svg": [
		60174,
		60174
	],
	"./filled/maiores-limites.svg": [
		556,
		556
	],
	"./filled/mala.svg": [
		92001,
		92001
	],
	"./filled/maquina-cartao.svg": [
		72959,
		72959
	],
	"./filled/maquina-fotografica.svg": [
		47358,
		47358
	],
	"./filled/maquina-pos.svg": [
		74845,
		74845
	],
	"./filled/maximizar.svg": [
		45926,
		45926
	],
	"./filled/metro.svg": [
		36125,
		36125
	],
	"./filled/microfone.svg": [
		15612,
		15612
	],
	"./filled/minimizar.svg": [
		4404,
		4404
	],
	"./filled/notificacao.svg": [
		98056,
		98056
	],
	"./filled/olho-ativo.svg": [
		18910,
		18910
	],
	"./filled/olho-inativo.svg": [
		18913,
		18913
	],
	"./filled/onibus.svg": [
		40560,
		40560
	],
	"./filled/orientador-de-credito.svg": [
		6078,
		6078
	],
	"./filled/pagamento-ao-fornecedor.svg": [
		13093,
		13093
	],
	"./filled/paixao.svg": [
		75800,
		75800
	],
	"./filled/parcelamento.svg": [
		69065,
		69065
	],
	"./filled/pdf.svg": [
		2360,
		2360
	],
	"./filled/perfil-do-investidor.svg": [
		71804,
		71804
	],
	"./filled/pers-conta.svg": [
		77336,
		77336
	],
	"./filled/pet.svg": [
		16285,
		16285
	],
	"./filled/pix-pix.svg": [
		39457,
		39457
	],
	"./filled/play.svg": [
		60932,
		60932
	],
	"./filled/portabilidade.svg": [
		96178,
		96178
	],
	"./filled/poupanca.svg": [
		62335,
		62335
	],
	"./filled/premio.svg": [
		18286,
		18286
	],
	"./filled/presente.svg": [
		42992,
		42992
	],
	"./filled/prevencao-de-fraude.svg": [
		17037,
		17037
	],
	"./filled/previdencia.svg": [
		31636,
		31636
	],
	"./filled/processos.svg": [
		67691,
		67691
	],
	"./filled/programa-de-pontos.svg": [
		11117,
		11117
	],
	"./filled/proibido-fumar.svg": [
		83842,
		83842
	],
	"./filled/projeto-sucessorio.svg": [
		24809,
		24809
	],
	"./filled/radio-button.svg": [
		74328,
		74328
	],
	"./filled/radio.svg": [
		6355,
		6355
	],
	"./filled/relatorios-financeiros.svg": [
		12556,
		12556
	],
	"./filled/relogio.svg": [
		39469,
		39469
	],
	"./filled/responder.svg": [
		76328,
		76328
	],
	"./filled/responsabilidade-social.svg": [
		31211,
		31211
	],
	"./filled/restaurar.svg": [
		57689,
		57689
	],
	"./filled/salario.svg": [
		45355,
		45355
	],
	"./filled/saldo.svg": [
		24697,
		24697
	],
	"./filled/salvar.svg": [
		88433,
		88433
	],
	"./filled/saude.svg": [
		42522,
		42522
	],
	"./filled/seguranca-da-informacao.svg": [
		34415,
		34415
	],
	"./filled/seguranca-patrimonial.svg": [
		52454,
		52454
	],
	"./filled/seguranca-redes-sociais.svg": [
		39063,
		39063
	],
	"./filled/seguranca.svg": [
		78745,
		78745
	],
	"./filled/seguro-auto.svg": [
		95865,
		95865
	],
	"./filled/seguro-cartao.svg": [
		89102,
		89102
	],
	"./filled/seguro-crianca.svg": [
		12313,
		12313
	],
	"./filled/seguro-de-credito.svg": [
		72772,
		72772
	],
	"./filled/seguro-empresas.svg": [
		32504,
		32504
	],
	"./filled/seguro-fraude.svg": [
		33419,
		33419
	],
	"./filled/seguro-mulher.svg": [
		31355,
		31355
	],
	"./filled/seguro-patrimonial.svg": [
		93348,
		93348
	],
	"./filled/seguro-pet.svg": [
		62287,
		62287
	],
	"./filled/seguro-prestamista.svg": [
		31809,
		31809
	],
	"./filled/seguro-renda.svg": [
		57774,
		57774
	],
	"./filled/seguro-residencial.svg": [
		30175,
		30175
	],
	"./filled/seguro-responsabilidade-social.svg": [
		74889,
		74889
	],
	"./filled/seguro-transporte.svg": [
		54660,
		54660
	],
	"./filled/seguro-viagem.svg": [
		4865,
		4865
	],
	"./filled/seguro-vida.svg": [
		97810,
		97810
	],
	"./filled/seguro.svg": [
		20419,
		20419
	],
	"./filled/selecao-terceiros-full.svg": [
		50163,
		50163
	],
	"./filled/senha-circulo.svg": [
		71719,
		71719
	],
	"./filled/senha.svg": [
		2757,
		2757
	],
	"./filled/sms-chat.svg": [
		31556,
		31556
	],
	"./filled/sonho-grande.svg": [
		74337,
		74337
	],
	"./filled/sorriso.svg": [
		53831,
		53831
	],
	"./filled/suporte.svg": [
		61168,
		61168
	],
	"./filled/sustentabilidade.svg": [
		29689,
		29689
	],
	"./filled/switch.svg": [
		97086,
		97086
	],
	"./filled/tablet.svg": [
		87338,
		87338
	],
	"./filled/teatro.svg": [
		56249,
		56249
	],
	"./filled/telefone.svg": [
		92608,
		92608
	],
	"./filled/timeline.svg": [
		86219,
		86219
	],
	"./filled/todos-pelo-cliente.svg": [
		59557,
		59557
	],
	"./filled/transporte.svg": [
		9306,
		9306
	],
	"./filled/twitter.svg": [
		35895,
		35895
	],
	"./filled/txt.svg": [
		63298,
		63298
	],
	"./filled/universitarios.svg": [
		15391,
		15391
	],
	"./filled/upload.svg": [
		92605,
		92605
	],
	"./filled/usuario.svg": [
		49334,
		49334
	],
	"./filled/veiculo.svg": [
		17377,
		17377
	],
	"./filled/venda.svg": [
		49608,
		49608
	],
	"./filled/vestuario.svg": [
		43144,
		43144
	],
	"./filled/vida-sustentavel.svg": [
		681,
		681
	],
	"./filled/vida.svg": [
		5880,
		5880
	],
	"./filled/video.svg": [
		8395,
		8395
	],
	"./filled/word.svg": [
		88314,
		88314
	],
	"./filled/xicara.svg": [
		72632,
		72632
	],
	"./likert/bad.svg": [
		38224,
		38224
	],
	"./likert/dislike.svg": [
		38380,
		38380
	],
	"./likert/idk.svg": [
		37283,
		37283
	],
	"./likert/like.svg": [
		17034,
		17034
	],
	"./likert/loved.svg": [
		11509,
		11509
	],
	"./outlined/acoes-grafico.svg": [
		56421,
		56421
	],
	"./outlined/acoes.svg": [
		83831,
		83831
	],
	"./outlined/adicionar.svg": [
		50754,
		50754
	],
	"./outlined/agencia-personalite.svg": [
		14617,
		14617
	],
	"./outlined/agencia.svg": [
		38050,
		38050
	],
	"./outlined/agil.svg": [
		62615,
		62615
	],
	"./outlined/ajuda.svg": [
		6935,
		6935
	],
	"./outlined/alimentacao.svg": [
		75712,
		75712
	],
	"./outlined/alvo.svg": [
		71570,
		71570
	],
	"./outlined/antecipacao-de-recebimento.svg": [
		2796,
		2796
	],
	"./outlined/aplicativos.svg": [
		77765,
		77765
	],
	"./outlined/aporte-de-capital.svg": [
		28588,
		28588
	],
	"./outlined/ar_condicionado.svg": [
		72164,
		72164
	],
	"./outlined/armario.svg": [
		21843,
		21843
	],
	"./outlined/arroba.svg": [
		4159,
		4159
	],
	"./outlined/assessoria.svg": [
		10455,
		10455
	],
	"./outlined/atendimento-telefonico.svg": [
		4127,
		4127
	],
	"./outlined/atendimento.svg": [
		31450,
		31450
	],
	"./outlined/atualizando.svg": [
		38179,
		60560
	],
	"./outlined/autoriza-pelo-celular.svg": [
		17105,
		17105
	],
	"./outlined/aviso.svg": [
		9200,
		9200
	],
	"./outlined/banco-de-caixa.svg": [
		62220,
		62220
	],
	"./outlined/beleza.svg": [
		89889,
		89889
	],
	"./outlined/beneficios.svg": [
		16345,
		16345
	],
	"./outlined/bike.svg": [
		83659,
		83659
	],
	"./outlined/biometria-facial.svg": [
		9013,
		9013
	],
	"./outlined/biometria.svg": [
		43352,
		43352
	],
	"./outlined/bomba-gas.svg": [
		54557,
		54557
	],
	"./outlined/brilho-nos-olhos.svg": [
		67825,
		67825
	],
	"./outlined/busca.svg": [
		9506,
		9506
	],
	"./outlined/cadastro-positivo.svg": [
		26613,
		26613
	],
	"./outlined/caixa-eletronico.svg": [
		29565,
		29565
	],
	"./outlined/caixas-exclusivos.svg": [
		58013,
		58013
	],
	"./outlined/calculadora.svg": [
		32933,
		32933
	],
	"./outlined/calendario.svg": [
		6686,
		6686
	],
	"./outlined/cambio.svg": [
		18193,
		18193
	],
	"./outlined/caminhao.svg": [
		43596,
		43596
	],
	"./outlined/caminhonete.svg": [
		22229,
		22229
	],
	"./outlined/cancela.svg": [
		32655,
		32655
	],
	"./outlined/carrinho.svg": [
		28114,
		28114
	],
	"./outlined/cartao-de-seguranca.svg": [
		57522,
		57522
	],
	"./outlined/cartao.svg": [
		61542,
		61542
	],
	"./outlined/carteira-digital.svg": [
		70796,
		70796
	],
	"./outlined/carteirada.svg": [
		24086,
		24086
	],
	"./outlined/carteiras-digitais.svg": [
		3283,
		3283
	],
	"./outlined/cartoes.svg": [
		62629,
		62629
	],
	"./outlined/celular-card.svg": [
		91429,
		91429
	],
	"./outlined/celular-pre-pago.svg": [
		37660,
		37660
	],
	"./outlined/celular.svg": [
		3134,
		3134
	],
	"./outlined/chat-aguardando.svg": [
		94133,
		94133
	],
	"./outlined/chat-entregue.svg": [
		9637,
		32018
	],
	"./outlined/chat-enviado.svg": [
		18509,
		18509
	],
	"./outlined/chat-erro.svg": [
		52747,
		52747
	],
	"./outlined/chave.svg": [
		21929,
		21929
	],
	"./outlined/check.svg": [
		50524
	],
	"./outlined/checkbox-indeterminado.svg": [
		61987,
		61987
	],
	"./outlined/checkbox-vazio.svg": [
		83375,
		83375
	],
	"./outlined/checkbox.svg": [
		74863,
		74863
	],
	"./outlined/cheque.svg": [
		1901,
		1901
	],
	"./outlined/chip.svg": [
		37514,
		37514
	],
	"./outlined/cifrao.svg": [
		64200,
		64200
	],
	"./outlined/cinema.svg": [
		77789,
		77789
	],
	"./outlined/cobranca.svg": [
		19379,
		19379
	],
	"./outlined/codigo-de-barras.svg": [
		68943,
		68943
	],
	"./outlined/coleta.svg": [
		11006,
		11006
	],
	"./outlined/compartilhar.svg": [
		14592,
		14592
	],
	"./outlined/compra.svg": [
		32170,
		32170
	],
	"./outlined/compras.svg": [
		78133,
		78133
	],
	"./outlined/comprovante.svg": [
		23922,
		23922
	],
	"./outlined/computador.svg": [
		53170,
		53170
	],
	"./outlined/conectcar-adesivo.svg": [
		14328,
		14328
	],
	"./outlined/conectcar.svg": [
		6346,
		6346
	],
	"./outlined/configuracao.svg": [
		23691,
		23691
	],
	"./outlined/confirmacao.svg": [
		32632,
		32632
	],
	"./outlined/cons-investimento.svg": [
		71115,
		71115
	],
	"./outlined/cons-investimentos.svg": [
		18978,
		18978
	],
	"./outlined/consorcio-auto.svg": [
		84725,
		84725
	],
	"./outlined/consorcio-imobiliario.svg": [
		38618,
		38618
	],
	"./outlined/consorcio.svg": [
		24839,
		24839
	],
	"./outlined/conta-corrente.svg": [
		85828,
		85828
	],
	"./outlined/contatos.svg": [
		63793,
		63793
	],
	"./outlined/conti-negocios.svg": [
		33361,
		33361
	],
	"./outlined/contraste-off.svg": [
		52651,
		52651
	],
	"./outlined/contraste-on.svg": [
		38095,
		38095
	],
	"./outlined/copiar.svg": [
		38810
	],
	"./outlined/coracao.svg": [
		58352,
		58352
	],
	"./outlined/craques.svg": [
		57898,
		57898
	],
	"./outlined/credito-auto.svg": [
		25090,
		25090
	],
	"./outlined/credito-automatico.svg": [
		67931,
		67931
	],
	"./outlined/credito-consignado.svg": [
		71252,
		71252
	],
	"./outlined/credito-imobiliario.svg": [
		11711,
		11711
	],
	"./outlined/credito-sob-medida.svg": [
		98988,
		98988
	],
	"./outlined/credito.svg": [
		62486,
		62486
	],
	"./outlined/csv.svg": [
		71660,
		71660
	],
	"./outlined/cultura.svg": [
		44894,
		44894
	],
	"./outlined/curtir.svg": [
		47927,
		47927
	],
	"./outlined/debito.svg": [
		6253,
		6253
	],
	"./outlined/dente.svg": [
		85024,
		85024
	],
	"./outlined/deposito.svg": [
		22613,
		22613
	],
	"./outlined/desafios.svg": [
		6472,
		6472
	],
	"./outlined/desbloqueio.svg": [
		55076,
		55076
	],
	"./outlined/descurtir.svg": [
		33303,
		33303
	],
	"./outlined/diario.svg": [
		52152,
		52152
	],
	"./outlined/documento.svg": [
		36842,
		36842
	],
	"./outlined/documentos-pasta.svg": [
		79151,
		79151
	],
	"./outlined/download.svg": [
		43996,
		43996
	],
	"./outlined/e-comercial.svg": [
		64935,
		64935
	],
	"./outlined/editar.svg": [
		98881,
		98881
	],
	"./outlined/email-resposta-rapida.svg": [
		27190,
		27190
	],
	"./outlined/empresas.svg": [
		30352,
		30352
	],
	"./outlined/emprestimo.svg": [
		28665,
		28665
	],
	"./outlined/enviar.svg": [
		99159,
		99159
	],
	"./outlined/esporte.svg": [
		68326,
		68326
	],
	"./outlined/euro.svg": [
		67655,
		67655
	],
	"./outlined/excel.svg": [
		30909,
		30909
	],
	"./outlined/excluir.svg": [
		50058,
		50058
	],
	"./outlined/extrato.svg": [
		64693,
		64693
	],
	"./outlined/facebook.svg": [
		2328,
		2328
	],
	"./outlined/faceid.svg": [
		91520,
		91520
	],
	"./outlined/fatura.svg": [
		63825,
		63825
	],
	"./outlined/favorito.svg": [
		71410,
		71410
	],
	"./outlined/fechar.svg": [
		84555,
		84555
	],
	"./outlined/feedback.svg": [
		89913,
		89913
	],
	"./outlined/ferramentas.svg": [
		52940,
		52940
	],
	"./outlined/filtro.svg": [
		89770,
		89770
	],
	"./outlined/fingerprint.svg": [
		28608,
		28608
	],
	"./outlined/flash-desabilitado.svg": [
		60026,
		60026
	],
	"./outlined/flash-habilitado.svg": [
		76902,
		76902
	],
	"./outlined/futebol.svg": [
		32365,
		32365
	],
	"./outlined/garantia.svg": [
		62683,
		62683
	],
	"./outlined/gerenciador-de-vendas.svg": [
		90451,
		90451
	],
	"./outlined/gerente-dedicado.svg": [
		93936,
		93936
	],
	"./outlined/gerente.svg": [
		19082,
		19082
	],
	"./outlined/gestao-de-crises.svg": [
		24447,
		24447
	],
	"./outlined/globo.svg": [
		23769,
		23769
	],
	"./outlined/historico-de-rentabilidade.svg": [
		22253,
		22253
	],
	"./outlined/home.svg": [
		93745,
		93745
	],
	"./outlined/icarros.svg": [
		15419,
		15419
	],
	"./outlined/imposto-de-renda.svg": [
		14764,
		14764
	],
	"./outlined/impressora.svg": [
		55605,
		55605
	],
	"./outlined/informação.svg": [
		93085,
		93085
	],
	"./outlined/inovacao.svg": [
		66694,
		66694
	],
	"./outlined/inss.svg": [
		87675,
		87675
	],
	"./outlined/instagram.svg": [
		72704,
		72704
	],
	"./outlined/institucional.svg": [
		69576,
		69576
	],
	"./outlined/investimento.svg": [
		52307,
		52307
	],
	"./outlined/iso.svg": [
		34115,
		34115
	],
	"./outlined/itaupass.svg": [
		14518,
		14518
	],
	"./outlined/itoken-chaveiro-1.svg": [
		67680,
		67680
	],
	"./outlined/itoken-chaveiro.svg": [
		98018,
		98018
	],
	"./outlined/itoken.svg": [
		66204,
		66204
	],
	"./outlined/jornal.svg": [
		91986,
		91986
	],
	"./outlined/juros.svg": [
		5773,
		5773
	],
	"./outlined/lavagem-de-dinheiro.svg": [
		43846,
		43846
	],
	"./outlined/lideranca.svg": [
		27663,
		27663
	],
	"./outlined/limite.svg": [
		87202,
		87202
	],
	"./outlined/link-externo.svg": [
		71138,
		71138
	],
	"./outlined/loja.svg": [
		22836,
		22836
	],
	"./outlined/maioires-limites-alt.svg": [
		24239,
		24239
	],
	"./outlined/maiores-limites.svg": [
		98990,
		98990
	],
	"./outlined/mais.svg": [
		86942,
		53993
	],
	"./outlined/mala.svg": [
		83647,
		83647
	],
	"./outlined/maquina-cartao.svg": [
		48997,
		48997
	],
	"./outlined/maquina-fotografica.svg": [
		5344,
		5344
	],
	"./outlined/maquina-pos.svg": [
		93419,
		93419
	],
	"./outlined/maximizar.svg": [
		34227,
		56608
	],
	"./outlined/menos.svg": [
		68106,
		68106
	],
	"./outlined/menu-hamburger.svg": [
		71119,
		71119
	],
	"./outlined/metro.svg": [
		76895,
		76895
	],
	"./outlined/microfone.svg": [
		56606,
		56606
	],
	"./outlined/moto.svg": [
		89455,
		89455
	],
	"./outlined/nfc.svg": [
		42235,
		42235
	],
	"./outlined/notificacao.svg": [
		84634,
		84634
	],
	"./outlined/olho-ativo.svg": [
		72236,
		72236
	],
	"./outlined/olho-inativo.svg": [
		19451,
		19451
	],
	"./outlined/onibus.svg": [
		46982,
		46982
	],
	"./outlined/open-finance.svg": [
		64997,
		64997
	],
	"./outlined/ordenar-crescente.svg": [
		94992,
		94992
	],
	"./outlined/ordenar-decrescente.svg": [
		41335,
		41335
	],
	"./outlined/ordenar-direita.svg": [
		31336,
		31336
	],
	"./outlined/ordenar-esquerda.svg": [
		27244,
		27244
	],
	"./outlined/ordenar.svg": [
		53785,
		53785
	],
	"./outlined/orientacao-de-credito.svg": [
		3548,
		3548
	],
	"./outlined/outros.svg": [
		44400,
		44400
	],
	"./outlined/pagamento-ao-fornecedor.svg": [
		5019,
		5019
	],
	"./outlined/pagamentos.svg": [
		62635,
		62635
	],
	"./outlined/paixao.svg": [
		92186,
		92186
	],
	"./outlined/parcelamento.svg": [
		25807,
		25807
	],
	"./outlined/pause.svg": [
		76634,
		76634
	],
	"./outlined/pdf.svg": [
		34806,
		34806
	],
	"./outlined/perfil-do-investidor.svg": [
		19954,
		19954
	],
	"./outlined/pers-conta.svg": [
		79690,
		79690
	],
	"./outlined/pet.svg": [
		74983,
		74983
	],
	"./outlined/pix.svg": [
		87487,
		87487
	],
	"./outlined/play.svg": [
		16538,
		16538
	],
	"./outlined/porcentagem.svg": [
		86263,
		86263
	],
	"./outlined/portabilidade.svg": [
		77464,
		77464
	],
	"./outlined/poupanca.svg": [
		91993,
		91993
	],
	"./outlined/predio.svg": [
		29961,
		29961
	],
	"./outlined/premio.svg": [
		48812,
		48812
	],
	"./outlined/presente.svg": [
		92210,
		92210
	],
	"./outlined/prevencao-de-fraude.svg": [
		19547,
		19547
	],
	"./outlined/previdencia.svg": [
		98022,
		98022
	],
	"./outlined/processos.svg": [
		71377,
		71377
	],
	"./outlined/produtos.svg": [
		1918,
		1918
	],
	"./outlined/programa-de-pontos.svg": [
		35099,
		35099
	],
	"./outlined/proibido-fumar.svg": [
		50128,
		50128
	],
	"./outlined/projeto-sucessorio.svg": [
		93755,
		93755
	],
	"./outlined/qrcode.svg": [
		40242,
		40242
	],
	"./outlined/radio-button.svg": [
		23298,
		23298
	],
	"./outlined/radio.svg": [
		69469,
		69469
	],
	"./outlined/recarga.svg": [
		41779,
		41779
	],
	"./outlined/recarregar.svg": [
		87642,
		87642
	],
	"./outlined/refresh.svg": [
		7373,
		7373
	],
	"./outlined/relatorios-financeiros.svg": [
		41978,
		41978
	],
	"./outlined/relogio.svg": [
		36335,
		36335
	],
	"./outlined/resgate.svg": [
		59847,
		59847
	],
	"./outlined/responder.svg": [
		51830,
		51830
	],
	"./outlined/responsabilidade-social.svg": [
		78513,
		78513
	],
	"./outlined/resposta.svg": [
		30365,
		30365
	],
	"./outlined/restaurar.svg": [
		25339,
		25339
	],
	"./outlined/sacola.svg": [
		82199,
		82199
	],
	"./outlined/sair-do-vermelho.svg": [
		21846,
		21846
	],
	"./outlined/sair.svg": [
		38661,
		38661
	],
	"./outlined/salario.svg": [
		10257,
		10257
	],
	"./outlined/saldo.svg": [
		99987,
		99987
	],
	"./outlined/salvar.svg": [
		28171,
		28171
	],
	"./outlined/saque.svg": [
		13891,
		13891
	],
	"./outlined/saude.svg": [
		84952,
		84952
	],
	"./outlined/seguranca-da-informacao.svg": [
		14461,
		14461
	],
	"./outlined/seguranca-patrimonial.svg": [
		51712,
		51712
	],
	"./outlined/seguranca-redes-sociais.svg": [
		5741,
		5741
	],
	"./outlined/seguranca.svg": [
		51087,
		51087
	],
	"./outlined/seguro-auto.svg": [
		75191,
		75191
	],
	"./outlined/seguro-cartao.svg": [
		62748,
		62748
	],
	"./outlined/seguro-crianca.svg": [
		33271,
		33271
	],
	"./outlined/seguro-de-credito.svg": [
		88098,
		88098
	],
	"./outlined/seguro-empresas.svg": [
		99198,
		99198
	],
	"./outlined/seguro-fraude.svg": [
		14389,
		14389
	],
	"./outlined/seguro-mulher.svg": [
		36825,
		36825
	],
	"./outlined/seguro-patrimonial.svg": [
		18742,
		18742
	],
	"./outlined/seguro-pet.svg": [
		95653,
		95653
	],
	"./outlined/seguro-prestamista.svg": [
		73515,
		73515
	],
	"./outlined/seguro-renda.svg": [
		55532,
		55532
	],
	"./outlined/seguro-residencial.svg": [
		40725,
		40725
	],
	"./outlined/seguro-responsabilidade-social.svg": [
		57795,
		57795
	],
	"./outlined/seguro-transporte.svg": [
		85234,
		85234
	],
	"./outlined/seguro-viagem.svg": [
		47243,
		47243
	],
	"./outlined/seguro-vida.svg": [
		82112,
		82112
	],
	"./outlined/seguro.svg": [
		77865,
		77865
	],
	"./outlined/selecao-terceiros.svg": [
		91469,
		91469
	],
	"./outlined/sem-anuidade.svg": [
		67217,
		67217
	],
	"./outlined/senha-box.svg": [
		59947,
		59947
	],
	"./outlined/senha-circulo.svg": [
		1777,
		1777
	],
	"./outlined/seta-baixo-achatada.svg": [
		58763,
		58763
	],
	"./outlined/seta-baixo.svg": [
		59873,
		53993
	],
	"./outlined/seta-cima-achatada.svg": [
		49716,
		49716
	],
	"./outlined/seta-cima.svg": [
		84876,
		84876
	],
	"./outlined/seta-direita.svg": [
		66356,
		53993
	],
	"./outlined/seta-esquerda.svg": [
		17960,
		17960
	],
	"./outlined/sms-chat.svg": [
		68686,
		68686
	],
	"./outlined/sonho-grande.svg": [
		20299,
		20299
	],
	"./outlined/sorriso.svg": [
		51401,
		51401
	],
	"./outlined/suporte.svg": [
		30566,
		30566
	],
	"./outlined/sustentabilidade.svg": [
		47959,
		47959
	],
	"./outlined/swipe.svg": [
		1186,
		1186
	],
	"./outlined/switch.svg": [
		67776,
		67776
	],
	"./outlined/tablet.svg": [
		36820,
		36820
	],
	"./outlined/teatro.svg": [
		23423,
		23423
	],
	"./outlined/telefone.svg": [
		37866,
		37866
	],
	"./outlined/timeline.svg": [
		56325,
		56325
	],
	"./outlined/todos-pelo-cliente.svg": [
		80323,
		80323
	],
	"./outlined/tooltip.svg": [
		40893,
		40893
	],
	"./outlined/transferencia.svg": [
		33497,
		33497
	],
	"./outlined/transporte.svg": [
		82572,
		82572
	],
	"./outlined/tv.svg": [
		4254,
		4254
	],
	"./outlined/twitter.svg": [
		12041,
		12041
	],
	"./outlined/txt.svg": [
		97812,
		97812
	],
	"./outlined/universitarios.svg": [
		60537,
		60537
	],
	"./outlined/upload.svg": [
		18575,
		18575
	],
	"./outlined/user.svg": [
		43909,
		53993
	],
	"./outlined/veiculo.svg": [
		1983,
		1983
	],
	"./outlined/venda.svg": [
		63458,
		63458
	],
	"./outlined/vestuario.svg": [
		41682,
		41682
	],
	"./outlined/viagem.svg": [
		60553,
		60553
	],
	"./outlined/vida-sustentavel.svg": [
		81779,
		81779
	],
	"./outlined/vida.svg": [
		1802,
		1802
	],
	"./outlined/video.svg": [
		54205,
		54205
	],
	"./outlined/whatsapp.svg": [
		6438,
		6438
	],
	"./outlined/wifi.svg": [
		39915,
		39915
	],
	"./outlined/word.svg": [
		13020,
		13020
	],
	"./outlined/xicara.svg": [
		67046,
		67046
	],
	"./up-arrow-orange.svg": [
		63283,
		63283
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 53779;
module.exports = webpackAsyncContext;